import { Component, inject, OnInit, signal } from '@angular/core';

import { faFlagCheckered, faHandWave } from '@fortawesome/pro-solid-svg-icons';

import { tap } from 'rxjs';
import { Question } from '@empathy/survey-core';

import { QuestionTypeConfig } from '../../../models/question-type-config.constants';
import { translationGroupKeys } from '../../../models/translations/translation-groups.constant';
import { EditorTranslationsService } from '../../../services/editor-translations.service';
import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-translations-questions-list',
  templateUrl: './translations-questions-list.component.html',
  styleUrls: ['./translations-questions-list.component.scss']
})
export class TranslationsQuestionsListComponent implements OnInit {
  surveyEditorService = inject(SurveyEditorService);
  translationsService = inject(EditorTranslationsService);

  questions$ = signal<Question[]>([]);
  count$ = signal(0);
  loading$ = signal(false);

  activeTranslationGroupKey$ = this.translationsService.activeTranslationGroupKey$;

  questionTypeConfig = QuestionTypeConfig;

  welcomeScreenGroupKey = translationGroupKeys.welcomeScreen;
  thankYouPageGroupKey = translationGroupKeys.thankYouPage;

  faHandWave = faHandWave;
  faFlagCheckered = faFlagCheckered;

  ngOnInit(): void {
    this.loading$.set(true);

    this.surveyEditorService.questions$
      .pipe(
        tap((questions) => this.count$.set(questions.length)),
        tap(() => this.loading$.set(false))
      )
      .subscribe((questions: Question[]) => {
        this.questions$.set(questions);
      });
  }
}
